import { render, staticRenderFns } from "./APagar-matricula.vue?vue&type=template&id=6a7cf8b5"
import script from "./APagar-matricula.vue?vue&type=script&lang=js"
export * from "./APagar-matricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports